import store  from '../redux/store'
import { USER_TYPE } from "../constants";

const useRouteGuard = () => {
  const userPermissions = store.getState().common.userPermissions;
  const getFeatureName = (featureName) =>{
    let localFeatureName;
    if(featureName === 'eTrack'){
      if(userPermissions?.userType === USER_TYPE.internalUser){
        localFeatureName =  'eTrackInternal';
      }else if(userPermissions?.userType === USER_TYPE.externalUser){
        localFeatureName = 'eTrackCustomer';
      }else {
        localFeatureName = null;
      }
    }else {
      localFeatureName = featureName;
    }
    return localFeatureName;
  }

  const getIsReadOnlyPermission = (featureName) => {
    let localFeatureName = getFeatureName(featureName);
    return userPermissions && localFeatureName ? userPermissions.userAuthorizations.find((item)=> item?.featureName === localFeatureName)?.isReadOnly : false; 
  }

  const get_CRUD_Permission = (featureName) => {
    let localFeatureName = getFeatureName(featureName);
    return userPermissions && localFeatureName ? userPermissions.userAuthorizations.find((item)=> item?.featureName === localFeatureName)?.canCreate : false;
  }

  const getLoggedInUserDetails = () => {
    return userPermissions.userLoginInfo || 0;
  }

  return {
    getIsReadOnlyPermission,
    get_CRUD_Permission,
    getLoggedInUserDetails
  }
}
export default useRouteGuard;
